<template>
  <div id="search">
    <div :class="[inputting ? 'search_trans_inputting' : 'search_trans']" @submit.native.prevent>
      <div class="self_motion_trans" @click="chooseLanguage" v-if="transLanguages === '自动检测语言'"  @mouseleave="hoverLanguageListOut">
        {{transLanguages}}
        <span :class="[ !showChooseLanguage ? 'rotate_restore triangle' : 'rotate triangle']"></span>
      </div>
      <div class="trans_languages" @click="chooseLanguage" v-if="transLanguages !== '自动检测语言'" @mouseover="hoverIn" @mouseout="hoverOut">
        <p>{{transLanguages.from}}</p>
        <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/iconblack.png" v-show="!languagesHoverStatus" alt="">
        <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/iconred.png" v-show="languagesHoverStatus" alt="">
        <p>{{transLanguages.to}}</p>
        <span class="triangle"></span>
      </div>
      <input class="search_url" @keydown.13="trans()" ref="searchUrl" v-model="searchUrl" placeholder="请输入网址" @focus="searchTextInputting()" @blur="blurInputting" />
    </div>
    <button class="search" @click="trans"></button>
    <div class="options">
      <p v-for="(item, index) in options" :class="[item.selected ? 'selected' : '']" :key="index" @click="chooseTransWay(index)">{{item.text}}</p>
    </div>
    <ul class="language_options" v-if="showChooseLanguage" @mouseleave="hoverLanguageListOut" @mouseenter="hoverLanguageListIn">
      <li @click="changeTargetLanguage(-1)">
        <p :class="{selected : automaticCheck}">自动检测语言</p>
      </li>
      <li v-for="(item, index) in languageOptions" :key="index" @click="changeTargetLanguage(index)">
        <p :class="[item.selected ? 'selected' : '']">
          {{item.from}}
          <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/iconblack.png" v-if="!item.selected" class="arrows"/>
          <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/icon_white.png" v-if="item.selected" class="arrows"/>
          {{item.to}}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { checkLink, getParameter } from "./../libs/utils.js";
export default {
  name: "Search",
  props: ['userTurnUrl'],
  data() {
    return {
      searchUrl: "",
      transLanguages: "自动检测语言",
      languagesHoverStatus: false,
      showChooseLanguage: false,
      showChooseLanguageStatus: false,
      showLanuageListTimer: "",
      automaticCheck: false,
      transType: 1,
      inputting: false,
      transTo: "auto",
      transFrom: "auto",
      options: [
        {
          val: 1,
          text: "译文",
          selected: true
        },
        {
          val: 2,
          text: "原文+译文",
          selected: false
        },
        {
          val: 0,
          text: "原文",
          selected: false
        }
      ],
      languageOptions: [
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "英语",
          label: "中文 >> 英语",
          toVal: "en",
          selected: false
        },
        {
          from: "英语",
          fromVal: 'en',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "日语",
          toVal: "ja",
          selected: false
        },
        {
          from: "日语",
          fromVal: 'ja',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "韩语",
          toVal: "ko",
          selected: false
        },
        {
          from: "韩语",
          fromVal: 'ko',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "法语",
          toVal: "fr",
          selected: false
        },
        {
          from: "法语",
          fromVal: 'fr',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "德语",
          toVal: "de",
          selected: false
        },
        {
          from: "德语",
          fromVal: 'de',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },

        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "俄语",
          toVal: "ru",
          selected: false
        },
        {
          from: "俄语",
          fromVal: 'ru',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "西班牙语",
          toVal: "es",
          selected: false
        },
        {
          from: "西班牙语",
          fromVal: 'es',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "葡萄牙语",
          toVal: "pt",
          selected: false
        },
        {
          from: "葡萄牙语",
          fromVal: 'pt',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "意大利语",
          toVal: "it",
          selected: false
        },
        {
          from: "意大利语",
          fromVal: 'it',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "越南语",
          toVal: "vi",
          selected: false
        },
        {
          from: "越南语",
          fromVal: 'vi',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "印尼语",
          toVal: "id",
          selected: false
        },
        {
          from: "印尼语",
          fromVal: 'id',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        },
        {
          from: "中文",
          fromVal: 'zh-CHS',
          to: "阿拉伯语",
          toVal: "ar",
          selected: false
        },
        {
          from: "阿拉伯语",
          fromVal: 'ar',
          to: "中文",
          toVal: "zh-CHS",
          selected: false
        }
      ]
    };
  },
  watch: {
    searchUrl: function() {
      this.inputting = true;
    },
    '$route': function () {
      let searchUrl = getParameter('url');
      if (searchUrl != "" && searchUrl != undefined && searchUrl != null) {
        this.searchUrl = searchUrl;
      } else {
        this.searchUrl = ''
      }
    },
    userTurnUrl: function(val) {
      this.searchUrl = val
    }
  },
  mounted() {
    let that = this
    let searchUrl = getParameter('url');
    let from = getParameter("from") != "" ? getParameter("from"): this.transFrom;
    let type = getParameter("type") != "" ? getParameter("type") : this.transType;
    let to = getParameter("to") != "" ? getParameter("to") : this.transTo;
    this.transType = type
    let options = this.options.concat();
    options.forEach((item, index) => {
      item.selected = false;
      if(item.val == type) {
        options[index].selected = true;
        this.transType = options[index].val;
        this.options = options;
      }
    });
    if (typeof window.postMessage != "undefined") {
      // 检查浏览器是否支持postMessage
      var reciever = function(e) {
        ////监听到事件之后的回调
        let data = typeof e.data == 'string' && that.isJsonString(e.data) ? JSON.parse(e.data) : e.data
        if (data.TransFrom && data.TransTo && that.transFrom == 'auto' && that.transTo == 'auto') {
          that.transFrom = data.TransFrom
          that.transTo = data.TransTo
          that.languageOptions.forEach((item, index) => {
            if(item.fromVal == data.TransFrom && item.toVal == data.TransTo) {
              that.transLanguages = that.languageOptions[index];
            }
          });
        }
      };
      if (window.addEventListener) {
        //兼容监听绑定事件---addEventListener：不带on
        window.addEventListener("message", reciever, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", reciever);
      }
    }
    let languageOptions = this.languageOptions;
    if (
      to != "" &&
      to != undefined &&
      to != null &&
      from != "" &&
      from != undefined &&
      from != null
    ) {
      for (let i = 0; i < languageOptions.length; i++) {
        if (languageOptions[i].fromVal === from && languageOptions[i].toVal === to) {
          this.transLanguages = languageOptions[i];
          break;
        }
      }
    } else {
      this.automaticCheck = true;
    }
    // from=中文&to=英文
    if (searchUrl != "" && searchUrl != undefined && searchUrl != null) {
      this.searchUrl = searchUrl;
    }
  },
  methods: {
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
            return true;
        }
      } catch(e) {
        return false;
      }
    },
    chooseTransWay(index) {
      // 选择翻译的方式 原本+译文、原文、译文
      let options = this.options.concat();
      options.forEach((item) => {
        item.selected = false;
      });
      options[index].selected = true;
      this.transType = options[index].val;
      this.options = options;
      this.trans();
    },
    hoverLanguageListIn() {
      window.clearInterval(this.showLanuageListTimer);
    },
    hoverLanguageListOut() {
      this.showLanuageListTimer = setTimeout(() => {
        this.showChooseLanguage = false;
      }, 500);
    },
    chooseLanguage() {
      this.showChooseLanguage = !this.showChooseLanguage;
    },
    changeTargetLanguage(index) {
      // 选择翻译的目标语言
      let languageOptions = this.languageOptions.concat();
      languageOptions.forEach((item) => {
        item.selected = false;
      });
      this.showChooseLanguage = false;
      if (index == -1) {
        this.transTo = "auto";
        this.transFrom = "auto"
        this.transLanguages = "自动检测语言";
        this.automaticCheck = true;
        return;
      }
      this.automaticCheck = false;
      languageOptions[index].selected = true;
      this.transTo = languageOptions[index].toVal;
      this.transFrom = languageOptions[index].fromVal;
      this.transLanguages = languageOptions[index];
      this.languageOptions = languageOptions;
      this.trans();
    },
    trans() {
      this.searchUrl = this.searchUrl.trim()
      if (this.searchUrl == "") {
        return;
      }
      let transFrom = this.transFrom
      let transTo = this.transTo
      let transType = this.transType
      window.location.href = `http://webtrans.yodao.com/webTransPc/index.html?from=${transFrom}&to=${transTo}&type=${transType}&url=${encodeURIComponent(this.searchUrl)}`
      // window.location.href = `http://c.youdao.com/test/fanyi/index.html?from=${transFrom}&to=${transTo}&type=${transType}&url=${encodeURIComponent(this.searchUrl)}`
      // window.location.href = `http://fanyi-test.youdao.com/server/webTrans-test.html?from=${transFrom}&to=${transTo}&type=${transType}&url=${encodeURIComponent(this.searchUrl)}`
      // window.location.href = `http://10.237.92.26:8080/?from=${transFrom}&to=${transTo}&type=${transType}&url=${encodeURIComponent(this.searchUrl)}`
    },
    searchTextInputting() {
      this.showChooseLanguage = false;
      this.inputting = true;
      this.$refs.searchUrl.select();
    },
    blurInputting() {
      this.inputting = false;
    },
    hoverIn() {
      this.languagesHoverStatus = true;
    },
    hoverOut() {
      this.languagesHoverStatus = false;
    }
  }
};
</script>

<style scoped>
#search {
  float: left;
  position: relative;
}
#search .options {
  height: 38px;
  float: left;
  margin-top: 17px;
  border-radius: 3px;
  font-size: 0;
  overflow: hidden;
  border: 1px solid rgba(240, 241, 245, 1);
}
#search .options p {
  height: 38px;
  display: inline-block;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(89, 87, 87, 1);
  line-height: 38px;
  padding: 0 16px;
}

#search .options p:hover {
  color: #e02433;
}
#search .options .selected {
  font-weight: 600;
  color: rgba(224, 36, 51, 1);
  background: rgba(240, 241, 245, 1);
}
.search_trans {
  width: 463px;
  height: 38px;
  float: left;
  margin: 17px 0 0 0;
  overflow: hidden;
  border-radius: 3px 0 0 3px;
  border-left: 1px;
  border-top: 1px;
  border-bottom: 1px;
  border-style: solid;
  border-color: #f0f1f5 !important;
}
.search_trans_inputting {
  width: 463px;
  height: 38px;
  float: left;
  margin: 17px 0 0 0;
  overflow: hidden;
  border-radius: 3px 0 0 3px;
  border-left: 1px;
  border-top: 1px;
  border-bottom: 1px;
  border-style: solid;
  border-color: rgba(224, 36, 51, 1);
}
.self_motion_trans {
  width: 153px;
  height: 38px;
  box-sizing: border-box;
  float: left;
  padding: 0 8px 0 18px;
  line-height: 38px;
  font-weight: 400;
  color: rgba(43, 43, 43, 1);
  font-size: 14px;
}
.rotate {
  transform-origin: center center;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transition: transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -o-transition: -o-transform 0.2s;
  -ms-transition: -ms-transform 0.2s;
}

.rotate_restore {
  transform-origin: center center;
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(deg);
  -ms-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transition: transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  -o-transition: -o-transform 0.2s;
  -ms-transition: -ms-transform 0.2s;
}
.trans_languages {
  width: 153px;
  height: 38px;
  box-sizing: border-box;
  float: left;
  padding: 0 8px 0 16px;
  line-height: 38px;
  font-weight: 400;
  color: rgba(43, 43, 43, 1);
  font-size: 14px;
}
.trans_languages p {
  display: inline-block;
}
.trans_languages img {
  width: 8px;
  height: 8px;
  display: inline-block;
  margin: 0 7px;
}
.trans_languages:hover {
  color: rgba(224, 36, 51, 1);
}
.self_motion_trans:hover {
  color: rgba(224, 36, 51, 1);
}
.search_url::-webkit-input-placeholder {
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(201, 201, 201, 1);
  line-height: 20px;
}
.search_url {
  width: 270px;
  height: 20px;
  border-left: 1px solid #f0f1f5;
  margin-top: 9px;
  padding-left: 18px;
  box-sizing: border-box;
  display: block;
  float: left;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(43, 43, 43, 1);
  line-height: 20px;
}
.search {
  width: 38px;
  height: 40px;
  float: left;
  border-radius: 0px 3px 3px 0px;
  margin: 17px 36px 0 0;
  border: 0;
  background: url(https://shared-https.ydstatic.com/dict/market/webTransPc/images/Web_icon_Search.png);
  background-color: rgba(224, 36, 51, 1);
  background-size: 18px 18px;
  background-position: 11px 10px;
  background-repeat: no-repeat;
}
.triangle {
  width: 0;
  height: 0;
  float: right;
  display: block;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #c7c8c9;
  margin: 17px 0 0 0;
}
.language_options {
  width: 289px;
  height: 476px;
  z-index: 99;
  font-size: 0;
  padding: 18px 0 0 10px;
  box-sizing: border-box;
  position: absolute;
  top: 72px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 12px 24px 0px rgba(55, 61, 82, 0.15);
  border-radius: 3px;
  border: 1px solid rgba(240, 241, 245, 1);
}
.arrows {
  width: 8px;
  height: 8px;
  display: inline-block;
}
.language_options li {
  min-width: 122px;
  height: 30px;
  float: left;
  margin: 0 22px 5px 0;
}
.language_options li p {
  height: 30px;
  display: inline-block;
  box-sizing: border-box;
  padding: 0 8px;
  font-size: 14px;
  font-family: PingFangHK-Regular;
  font-weight: 400;
  color: rgba(43, 43, 43, 1);
  line-height: 30px;
}
.language_options li:nth-child(2n + 1) {
  margin: 0 0 5px 0;
}
.language_options li:first-child {
  float: none;
}
.language_options li p:hover {
  background: rgba(240, 241, 245, 1);
  border-radius: 3px;
}
.language_options .selected {
  color: rgba(255, 255, 255, 1);
  background: rgba(224, 36, 51, 1) !important;
  border-radius: 3px;
}
</style>
